import React, { useCallback, useEffect, useState } from "react";
import {
  addFeedback,
  deleteFeedback,
  getAllFeedback,
} from "../../redux/services/feedbackSlice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { AiOutlineDelete } from "react-icons/ai";
import Table from "../../common/Table";
import Model from "../../common/Model";
import ConfirmationPage from "../../common/ConfirmationPage";
import FeedbackForm from "./feedbackForm";
import { exportToTablePDF } from "../../common/PdfFormat";

const Feedback = () => {
  const dispatch = useDispatch();
  const [feedback, setFeedback] = useState("");
  const [confirm, setConfirm] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [viewModelOpen, setViewModelOpen] = useState(false);
  const [modelOpen, setModelOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const limitOptions = [
    { value: 10, label: 10 },
    { value: 30, label: 30 },
    { value: 50, label: 50 },
    { value: 100, label: 100 },
  ];
  const [pageLimit, setPageLimit] = useState(limitOptions[0]?.value);
  const getFeedbackData = useSelector((state) => state?.feedback?.feedbackData);
  const getAllFeedbackApi = useCallback(async () => {
    try {
      await dispatch(getAllFeedback({ page: page + 1, limit: pageLimit }));
    } catch (error) {}
  }, [dispatch, page, pageLimit]);

  useEffect(() => {
    getAllFeedbackApi();
  }, [getAllFeedbackApi]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true)
    try {
      const response = await dispatch(addFeedback({ feedback: feedback }));
      if (response.payload.status === 200) {
        setFeedback("");
        setLoading(false)
        setModelOpen(false);
        getAllFeedbackApi();
        toast.success("Feedback submitted successfully!");
      }
    } catch (error) {
      setLoading(false);
    }
    finally{
      setLoading(false);
    }
  };
  const deleteFeedbackData = async () => {
    try {
      const response = await dispatch(deleteFeedback(itemToDelete));
      toast.success(response?.payload?.message, {
        autoClose: 2000,
        pauseOnHover: false,
      });
      setConfirm(false);
      getAllFeedbackApi();
    } catch (error) {}
  };
  const columns = [
    {
      label: "S/N",
      key: "index",
      render: (_, __, index) => page * pageLimit + index + 1,
    },
    {
      label: "Name",
      key: "userName",
      render: (_, row) => {
        if (!row?.user) {
          return "-";
        }
        return `${row?.user?.firstName + " " + row?.user?.lastName}`;
      },
    },
    {
      label: "Email",
      key: "email",
      render: (_, row) => row?.user?.email || "-",
    },
    {
      label: "Contact",
      key: "contact",
      render: (_, row) =>
        row?.user?.contact?.mobile
          ? `${row?.user?.contact?.countryCode} ${row?.user?.contact?.mobile}`
          : "-",
    },
    {
      label: "Feedback",
      key: "feedback",
      render: (value, row) =>
        value ? (
          <button
            className="w-[120px] h-9 bg-[#124699] rounded-md text-white cursor-pointer"
            onClick={() => {
              setViewModelOpen(true);
              setFeedback(row?.feedback);
            }}
          >
            View
          </button>
        ) : (
          row?.feedback
        ),
    },
  ];
  // React Table instance
  const actions = [
    {
      icon: <AiOutlineDelete className="w-6 h-6" />,
      onClick: (row) => {
        setItemToDelete(row._id);
        setConfirm(true);
      },
    },
  ];
  const exportToPDF = () => {
    const headersConfig = columns
    const data = getFeedbackData?.feedback_data || [];
    exportToTablePDF({
      tableName: "Feedback Data",
      data,
      headersConfig,
      pdfName: "feedback_data.pdf",
    });
  };
  return (
    <>
      <Table
        title="Feedback"
        buttonTitle="Add Feedback"
        onAddClick={() => setModelOpen(true)}
        columns={columns}
        data={getFeedbackData?.feedback_data || []}
        actions={actions}
        onPageChange={(selectedItem) => setPage(selectedItem.selected)}
        pageCount={getFeedbackData?.state?.page_limit}
        pageLimitOptions={limitOptions}
        selectedPageLimit={pageLimit}
        onPageLimitChange={setPageLimit}
        exportButton={true}
        onExport={exportToPDF}
      />
      {confirm && (
        <ConfirmationPage
          topicName="Feedback"
          confirm={confirm}
          onDelete={deleteFeedbackData}
          onCancel={() => setConfirm(false)}
        />
      )}
      {modelOpen && (
        <FeedbackForm
          feedback={feedback}
          setFeedback={setFeedback}
          onClose={() => {
            setModelOpen(false);
          }}
          handleSubmit={handleSubmit}
          loading={loading}
        />
      )}
      {viewModelOpen && (
        <Model closeModal={() => setViewModelOpen(false)} title="Feedback">
          <p>{feedback}</p>
        </Model>
      )}
    </>
  );
};

export default Feedback;
